import jQuery from "jquery";

const $ = jQuery;

class Alertbar {
    cookieName = 'closeAlert';

    constructor(element) {
        document.body.classList.add('notification-bar--not-visible');
        if (!element) {
            return;
        }
        this.element = element;
        this.header = document.querySelector('.header');

        if (this.getShouldHide()) {
            element.style.display = 'none';
            return;
        }

        document.body.classList.remove('notification-bar--not-visible');
        document.body.classList.add('notification-bar--visible');

        element.querySelector('.alertbar-close').addEventListener('click', this.onCloseBarClick);
    }

    getCookieValue = () => {
        const parts = document.cookie.split(`${this.cookieName}=`);
        if (parts.length <= 1) {
            return null;
        }
        return JSON.parse(decodeURIComponent(parts[1].split(';')[0]));
    }

    getShouldHide = () => {
        const cookieValue = this.getCookieValue();
        if (!cookieValue) {
            return false;
        }
        return cookieValue.ids.includes(this.element.id);
    }

    onCloseBarClick = () => {
        let ids = [this.element.id];
        const cookieValue = this.getCookieValue();
        if (cookieValue?.ids) {
            ids = [...ids, ...cookieValue.ids];
        }

        const value = encodeURIComponent(JSON.stringify({
            ids: ids,
        }));
        document.cookie = `${this.cookieName}=${value}; path=/;`;
        this.element.style.position = 'fixed';
        this.element.style.top = '';
        this.element.parentNode.style.height = '';
        this.element.classList.add('alertbar-hide');
        this.header.style.transition = 'top 0.6s ease 0s';
        this.header.style.top = '';
    }
}

const pageHeader = (($) => { // eslint-disable-line

    const init = () => {
        new Alertbar(document.querySelector('.alertbar'));
    };

    return {
        init,
    };
})(jQuery); // eslint-disable-line

export default pageHeader;
